import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useToast } from '../context/ToastContext';
import { authApi } from '../services/api';

const ForgotPassword = () => {
    const { addToast } = useToast();
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [emailSent, setEmailSent] = useState(false);

    const validateEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateEmail(email)) {
            addToast('Please enter a valid email address', 'error', 6000);
            return;
        }

        try {
            setIsLoading(true);
            const response = await authApi.forgotPassword({ email });
            
            setEmailSent(true);
            addToast(response.message || 'Password reset email sent!', 'success', 6000);
        } catch (error) {
            const errorMessage = error?.error || error?.message || 'Failed to send password reset email';
            addToast(errorMessage, 'error', 6000);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-black text-white" style={{ marginTop: '-96px' }}>
            <div className="bg-black p-8 rounded-lg shadow-md w-96">
                <h2 className="text-2xl font-semibold mb-4 text-center">Forgot Password</h2>
                
                {!emailSent ? (
                    <>
                        <p className="text-gray-300 mb-6 text-center">
                            Enter your email address and we'll send you a link to reset your password.
                        </p>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                                <label className="block mb-2">Email Address</label>
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full p-2 rounded border border-gray-300 text-black"
                                    placeholder="Enter your email"
                                    required
                                    disabled={isLoading}
                                    autoComplete="email"
                                />
                            </div>
                            <button 
                                type="submit"
                                className={`w-full p-2 bg-lime-400 text-black rounded hover:bg-lime-500 transition-colors ${
                                    isLoading ? 'opacity-50 cursor-not-allowed' : ''
                                }`}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Sending...' : 'Send Reset Link'}
                            </button>
                        </form>
                    </>
                ) : (
                    <div className="text-center">
                        <div className="mb-4">
                            <svg className="w-16 h-16 text-lime-400 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                        </div>
                        <p className="text-gray-300 mb-4">
                            If an account exists with this email, a password reset link has been sent.
                        </p>
                        <p className="text-sm text-gray-400 mb-6">
                            Please check your inbox and click the reset link. The link will expire in 24 hours.
                        </p>
                    </div>
                )}

                <p className="mt-4 text-center">
                    <Link to="/login" className="text-lime-400 hover:underline">Back to Login</Link>
                </p>
            </div>
        </div>
    );
};

export default ForgotPassword;

